import { Component, HostListener, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as moment from "moment-timezone";
import { ToastrService } from "ngx-toastr";
import { ApplicationService } from "services/application.service";
import { NavigationService } from "services/navigation.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-zoomactivatepopup",
  templateUrl: "./zoomactivatepopup.component.html",
  styleUrls: ["./zoomactivatepopup.component.scss"],
})
export class ZoomactivatepopupComponent implements OnInit {
  // form: FormGroup;
  applicationId: any;
  form: FormGroup;
  noloading: boolean;
  commPage: any;
  form1: FormGroup;
  deletepage: any;
  form2: FormGroup;
  form3: FormGroup;
  zoomact: any;
  maxLength: number = 0;
  voucheractivatepage: any;
  voucherappId: any;
  application: any;
  vouchercost: any;
  voucherproduct: any;
  voucherexpirydate: any;
  monthlist: any[] = [];
  month: any = [];
  monnu: any;
  voucherImage: any;
  vouchername: any;
  Openserverenew: any
  downloadspeed: any;
  voucherproductList: any;
  addResellerOrSalesRep: any;
  idToAddResellerOrSales: any;
  resellerList: any[] = [];
  salesRepList: any[] = [];
  resellerSalesRepList: any[] = [];


  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ZoomactivatepopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
    private applicationService: ApplicationService,
    private navigationService: NavigationService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    debugger;
    var today1 = new Date();
    let newdate = moment(today1).format("YYYY-MM-01");
    let t = new Date(newdate);
    t.setMonth(today1.getMonth() - 1);
    var today = new Date(t);
    let todayy = new Date(newdate);
    for (let i = 0; i < 6; i++) {
      todayy.setMonth(today.getMonth() + 1);
      today = new Date(todayy);
      var mon = moment(today).format("MMMM");
      this.monnu = moment(today).format("MM");
      this.monthlist[i] = { key: this.monnu, value: mon };
    }
    this.initializeValidators();
    this.applicationId = this.dataRecievedToAdd.appId;
    this.zoomact = this.dataRecievedToAdd.zoomact;
    this.commPage = this.dataRecievedToAdd.commPage;
    this.deletepage = this.dataRecievedToAdd.deletepage;
    this.voucheractivatepage = this.dataRecievedToAdd.zoomVoucherActivate;
    this.Openserverenew = this.dataRecievedToAdd.Openserverenew;
    this.addResellerOrSalesRep = this.dataRecievedToAdd.addResellerOrSalesRep;
    this.idToAddResellerOrSales = this.dataRecievedToAdd.idToAddResellerOrSales;

    if (this.voucheractivatepage == true) {
      this.voucherappId = this.dataRecievedToAdd.detail.voucherAppId;
      this.voucherproduct = this.dataRecievedToAdd.detail.vocuherproductname;
      this.vouchercost = this.dataRecievedToAdd.detail.voucherproductcost;
      this.voucherexpirydate = this.dataRecievedToAdd.detail.voucherexpirydate;
    }
    else if (this.Openserverenew == true) {
      this.downloadspeed = this.dataRecievedToAdd.detail.downloadspeed
      this.voucherappId = this.dataRecievedToAdd.detail.voucherAppId;
      this.voucherproduct = this.dataRecievedToAdd.detail.vocuherproductname;
      this.vouchercost = this.dataRecievedToAdd.detail.voucherproductcost;
      this.voucherexpirydate = this.dataRecievedToAdd.detail.voucherexpirydate;
      this.applicationService.getOpenserveVoucherProducts(this.downloadspeed).subscribe((Result) => {
        if (Result != null) {
          this.voucherproductList = Result.value;
        }
      })


    }
    this.voucherImage = this.dataRecievedToAdd.voucherImage;
    this.vouchername = this.dataRecievedToAdd.vouchername;

  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      netIdentifier: ["", [Validators.required]],
      month: ["", [Validators.required]],
    });

    this.form1 = this.formBuilder.group({
      content: ["", [Validators.required]],
    });

    this.form2 = this.formBuilder.group({
      reason: ["", [Validators.required]],
    });

    this.form3 = this.formBuilder.group({
      assignType: [""],
      resellerCode: [""],
      salesRepCode: [""],
      resellerSalesRep: [""]
    });
  }
  onsave() {
    if (this.form1.valid) {
      this.dialogRef.close(this.form1.value);
    } else {
      this.validateFormControl1();
    }
  }

  ondelete() {
    if (this.form2.valid) {
      this.dialogRef.close(this.form2.value);
    } else {
      this.validateFormControl2();
    }
  }

  onSubmit() {
    var data = {
      networkIdentifier: this.form.value.netIdentifier,
      month: this.form.value.month,
      ApplicationId: this.applicationId,
    };
    if (this.form.valid) {
      this.applicationService.zoomNetworkSave(data).subscribe((res) => {
        if (res.isSuccess) {
          this.dialogRef.close(false);
          this.toastr.success("Status Changed Successfully");
          // Swal.fire({
          //   position: 'top-end',
          //   icon: 'success',
          //   title: 'Status Changed Successfully',
          //   showConfirmButton: false,
          //   timer: 1500
          // })
        } else {
          this.dialogRef.close(false);
          this.toastr.error("Oops... Something went wrong!");
        }
      });
    } else {
      this.validateFormControl();
    }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  validateFormControl1() {
    Object.keys(this.form1.controls).forEach((field) => {
      const control = this.form1.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  validateFormControl2() {
    Object.keys(this.form2.controls).forEach((field) => {
      const control = this.form2.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  onCancel() {
    this.dialogRef.close(true);
    // this.noloading = true;
  }

  onInput(event) {
    debugger;
    this.maxLength = event.target.value.length;
  }

  // getApplicationList(appid) {
  //   // debugger

  //   this.applicationService.getApplicationListByApplicationId(appid).subscribe(result => {

  //     this.application = result;

  //   });
  // }

  onVoucherSubmit() {
    this.dialogRef.close(false);
  }


  onAssignTypeChange() {
    const type = this.form3.get('assignType')!.value;

    this.form3.get('resellerCode')!.setValue('');
    this.form3.get('salesRepCode')!.setValue('');
    this.form3.get('resellerSalesRep')!.setValue('');
    this.resellerSalesRepList = [];

    if (type === 'reseller') {
      if (!this.resellerList.length) {
        this.applicationService.getResellerCode().subscribe(result => {
          if (result) {
            this.resellerList = result;
          }
        });
      }

      this.form3.get('resellerCode')!.setValidators([Validators.required]);
      this.form3.get('salesRepCode')!.clearValidators();
    }
    else {
      if (!this.salesRepList.length) {
        this.applicationService.getSalesRepCode().subscribe(result => {
          if (result) {
            this.salesRepList = result;
          }
        });
      }

      this.form3.get('salesRepCode')!.setValidators([Validators.required]);
      this.form3.get('resellerCode')!.clearValidators();
    }

    this.form3.get('resellerCode')!.updateValueAndValidity();
    this.form3.get('salesRepCode')!.updateValueAndValidity();

  }

  onResellerChange() {
    const code = this.form3.get('resellerCode')!.value;
    this.resellerSalesRepList = [];
    this.form3.get('resellerSalesRep')!.setValue('');

    if (!code) {
      return;
    }

    this.applicationService.getResellerSalesListByResellerCode(code).subscribe(result => {
      if (result && result.length) {
        this.resellerSalesRepList = result;
        this.form3.get('resellerSalesRep')!.setValidators([Validators.required]);
      } else {
        this.resellerSalesRepList = [];
        this.form3.get('resellerSalesRep')!.clearValidators();
      }
      this.form3.get('resellerSalesRep')!.updateValueAndValidity();
    });
  }

  onSaveResellerRep() {
    var formValues = this.form3.value;

    if (!formValues.resellerCode && !formValues.salesRepCode) {
      this.toastr.warning("Select Reseller or Sales Rep Code");
      return;
    }
    else if (formValues.resellerCode && this.resellerSalesRepList.length > 0 && !formValues.resellerSalesRep) {
      this.toastr.warning("Select Reseller Sales Code");
      return;
    }
    const payload = {
      applicationId: this.idToAddResellerOrSales,
      resellerCode: formValues.resellerCode,
      salesRepCode: formValues.salesRepCode,
      resellerSalesCode: formValues.resellerSalesRep
    };
    this.applicationService.onSaveResellerRep(payload).subscribe(result => {
      if (result == true) {
        this.dialogRef.close(false);
        this.toastr.success("Updated Successfully");
      }
      else {
        this.toastr.error("Failed to Update");
      }
    });
  }
}

